export var getRenderPropValue = function getRenderPropValue(propValue) {
  if (!propValue) {
    return null;
  }
  var isRenderFunction = typeof propValue === 'function';
  if (isRenderFunction) {
    return propValue();
  }
  return propValue;
};